import { CONST } from "../../../src/const";

class PaytableWinningSchemes {
    static approxMinTotalSchemeSize: number = 130;
    static percentSquareReduction: number = 0.15;
    static fontSizeNumberLine: number = 48;
    static textNumberLineMarginBottom: number = 1.2;

    static createAndAdd(wrapper) {
        this.schemes.forEach((scheme, index) => {
            const textNumberLine = index + 1
            this.createAndAddWinningSchemeToContainer(wrapper, scheme, this.approxMinTotalSchemeSize, textNumberLine);
        });
    }

    static createAndAddWinningSchemeToContainer(container: any, scheme: boolean[][], approxMinTotalSchemeSize: number, numberLine: number): void {
        const reelsColumnsNum = CONST.COLUMNS
        const reelsRowsNum = CONST.ROWS

        const winningScheme = this.createWinningScheme(reelsColumnsNum, reelsRowsNum, scheme, approxMinTotalSchemeSize, numberLine);
        container.addChild(winningScheme);
    };

    static createWinningScheme(numHorizontal: number, numVertical: number, winningSquares, approxMinTotalSchemeSize: number, numberLine: number): PIXI.Container {
        if (!Array.isArray(winningSquares) || winningSquares.length !== numVertical) {
            console.error("Invalid scheme format!");
            return;
        }

        const graphics = this.createGraphics();
        const container = this.createContainer(`ui.menu.paytable.wrapper_payLines_schema.box_${numberLine}`);
        const squareHeight = approxMinTotalSchemeSize / numHorizontal;
        const squareWidth = approxMinTotalSchemeSize / numVertical;

        for (let i = 0; i < numVertical; i++) {
            if (!this.isValidScheme(winningSquares[i], numHorizontal)) {
                console.error("Invalid scheme format!");
                return;
            }

            for (let j = 0; j < numHorizontal; j++) {
                const x = j * squareWidth + (squareWidth * this.percentSquareReduction);
                const y = i * squareHeight + (squareHeight * this.percentSquareReduction);
                const smallerSquareWidth = squareWidth * (1 - this.percentSquareReduction);
                const smallerSquareHeight = squareHeight * (1 - this.percentSquareReduction);

                const color = winningSquares[i][j] ? 0xDEA329 : 0x29200D;

                this.drawSquare(graphics, x, y, smallerSquareWidth, smallerSquareHeight, color);
            }
        }

        const textNumberLine = this.createText(numberLine.toString());
        const containerTextPositionCenterX = (graphics.width / 2) + (textNumberLine.width / 4)
        const containerTextPositionMarginY = -(textNumberLine.height * this.textNumberLineMarginBottom)
        const containerText = this.createContainer(`ui.menu.paytable.wrapper_payLines_schema.box_textNumberLine_container`, containerTextPositionCenterX, containerTextPositionMarginY);

        //@ts-ignore
        containerText.addChild(textNumberLine);
        //@ts-ignore
        container.addChild(containerText);
        //@ts-ignore
        container.addChild(graphics);

        return container;
    }

    static drawSquare(graphics: any, x: number, y: number, width: number, height: number, color: number): void {
        graphics.beginFill(color);
        graphics.drawRect(x, y, width, height);
        graphics.endFill();
    }

    static isValidScheme(schema, numHorizontal: number): boolean {
        return Array.isArray(schema) && schema.length === numHorizontal;
    };

    static createGraphics() {
        //@ts-ignore
        return new PIXI.Graphics();
    };

    //@ts-ignore
    static createText(text: string): PIXI.Text {
        return game.builder.create(
            {
                "text": text,
                "type": "Text",
                "style": {
                    "fontFamily": "montserrat-bold",
                    "fill": "0xffffff",
                    "align": "center"
                },
                "fontSize": this.fontSizeNumberLine
            }
        )
    };

    static createContainer(name: string, positionX: number = 0, positionY: number = 0): PIXI.Container {
        return game.builder.create({
            "type": "Container",
            "name": name,
            "position": { "x": positionX, "y": positionY }
        });
    };

    static get schemes(): boolean[][][] {
        return [
            // 1
            [
                [true, true, true, true, true],
                [false, false, false, false, false],
                [false, false, false, false, false],
                [false, false, false, false, false]
            ],
            // 2
            [
                [false, false, false, false, false],
                [true, true, true, true, true],
                [false, false, false, false, false],
                [false, false, false, false, false]
            ],
            // 3
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [true, true, true, true, true],
                [false, false, false, false, false]
            ],
            // 4
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [false, false, false, false, false],
                [true, true, true, true, true]
            ],
            // 5
            [
                [true, false, false, false, true],
                [false, true, false, true, false],
                [false, false, true, false, false],
                [false, false, false, false, false]
            ],
            // 6
            [
                [false, false, false, false, false],
                [true, false, false, false, true],
                [false, true, false, true, false],
                [false, false, true, false, false]
            ],
            // 7
            [
                [false, false, true, false, false],
                [false, true, false, true, false],
                [true, false, false, false, true],
                [false, false, false, false, false]
            ],
            // 8
            [
                [false, false, false, false, false],
                [false, false, true, false, false],
                [false, true, false, true, false],
                [true, false, false, false, true]
            ],
            // 9
            [
                [true, false, true, false, true],
                [false, true, false, true, false],
                [false, false, false, false, false],
                [false, false, false, false, false]
            ],
            // 10
            [
                [false, false, false, false, false],
                [true, false, true, false, true],
                [false, true, false, true, false],
                [false, false, false, false, false]
            ],
            // 11
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [true, false, true, false, true],
                [false, true, false, true, false]
            ],
            // 12
            [
                [false, true, false, true, false],
                [true, false, true, false, true],
                [false, false, false, false, false],
                [false, false, false, false, false]
            ],
            // 13
            [
                [false, false, false, false, false],
                [false, true, false, true, false],
                [true, false, true, false, true],
                [false, false, false, false, false]
            ],
            // 14
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [false, true, false, true, false],
                [true, false, true, false, true]
            ],
            // 15
            [
                [true, false, false, false, true],
                [false, true, true, true, false],
                [false, false, false, false, false],
                [false, false, false, false, false]
            ],
            // 16
            [
                [false, false, false, false, false],
                [true, false, false, false, true],
                [false, true, true, true, false],
                [false, false, false, false, false]
            ],
            // 17
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [true, false, false, false, true],
                [false, true, true, true, false]
            ],
            // 18
            [
                [false, true, true, true, false],
                [true, false, false, false, true],
                [false, false, false, false, false],
                [false, false, false, false, false]
            ],
            // 19
            [
                [false, false, false, false, false],
                [false, true, true, true, false],
                [true, false, false, false, true],
                [false, false, false, false, false],
            ],
            // 20
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [false, true, true, true, false],
                [true, false, false, false, true],
            ],
            // 21
            [
                [true, true, false, true, true],
                [false, false, true, false, false],
                [false, false, false, false, false],
                [false, false, false, false, false],
            ],
            // 22
            [
                [false, false, false, false, false],
                [true, true, false, true, true],
                [false, false, true, false, false],
                [false, false, false, false, false],
            ],
            // 23
            [
                [false, false, false, false, false],
                [false, false, false, false, false],
                [true, true, false, true, true],
                [false, false, true, false, false],
            ],
            // 24
            [
                [false, false, true, false, false],
                [true, true, false, true, true],
                [false, false, false, false, false],
                [false, false, false, false, false],
            ],
            // 25
            [
                [false, false, false, false, false],
                [false, false, true, false, false],
                [true, true, false, true, true],
                [false, false, false, false, false],
            ]
        ]
    }
}

export { PaytableWinningSchemes }